import { useSpring } from 'react-spring'

export const useFade = ({ in: open, onEnter, onExited, ...rest }) => {
	const style = useSpring({
		from: { opacity: 0, transform: 'translateY(50px)' },
		to: { opacity: open ? 1 : 0, transform: `translateY(${open ? 0 : 50}px)` },
		delay: open ? 100 : 0,
		config: key => {
			switch (key) {
				case 'opacity': {
					return { duration: open ? 150 : 200 }
				}
				default:
					return { duration: open ? 200 : 150 }
			}
		},
		onStart: () => {
			if (open && onEnter) {
				onEnter()
			}
		},
		onRest: () => {
			if (!open && onExited) {
				onExited()
			}
		},
	})

	return [
		{
			...rest,
			style,
		},
	]
}
